/**
 * Google AdSense 설정
 * - client: 애드센스 게시자 ID (예: 'ca-pub-1234567890123456'). 비워두면 광고 영역이 렌더링되지 않습니다.
 * - slots: 광고 단위 ID. 애드센스 → 광고 → 광고 단위별 → 디스플레이 광고 만들기에서 발급.
 *   아직 없으면 ''로 두세요. 그 자리는 비워집니다.
 * index.html 의 <head> 에 있는 adsbygoogle 스크립트의 client 값도 함께 맞춰주세요.
 */
export const ADS = {
  client: 'ca-pub-7064513655636813',
  slots: {
    /** 메인 페이지 하단 */
    home: '',
    /** 대기실: 초대 링크 카드 아래 */
    lobby: '',
    /** 결과 화면: 공유 버튼 아래 */
    result: '',
    /** 메인 페이지 좌우 여백 세로 배너 (넓은 화면 전용, 160x600 고정 크기 단위) */
    sideLeft: '',
    sideRight: '',
  },
} as const;

export type AdSlotName = keyof typeof ADS.slots;

export function adsEnabled(): boolean {
  return ADS.client.length > 0;
}
